export default __webpack_public_path__ + "static/te_small-image_4-6a0df4c61e485feff3e5a19dc13be9b6.png";